// extracted by mini-css-extract-plugin
export var arrows = "_2m-6";
export var decrementer = "_2m-a";
export var disabled = "_2m-4";
export var error = "_2m-1";
export var hiddenText = "_2m-b";
export var incrementer = "_2m-9";
export var input = "_2m-8";
export var inputWrapper = "_2m-0";
export var leadingIcon = "_2m-c";
export var readonly = "_2m-3";
export var regular = "_2m-7";
export var small = "_2m-5";
export var warning = "_2m-2";